module.exports = __webpack_public_path__ + "img/marinaplaza.311a900f.svg";